import { Component, Input } from '@angular/core';
import { InternalActivationsCardContent } from '../../core-data-model/InternalActivations.model';

@Component({
    selector: 'internal-activations-card',
    template: `<div class="internal-activations-card">
        <div class="internal-activations-card-content-container">
            <div class="internal-activations-footer-card-image">
                <img src="{{ cardContent.imageSource }}" />
            </div>
            <div>
                @if (isDiagnosePage) {
                    <div
                        class="internal-activations-card-step internal-activations-card-margin"
                    >
                        {{ cardContent.step | translate | uppercase }}
                    </div>
                }
                <div
                    class="tapestry-body body--lg bold"
                    [ngClass]="{
                        'internal-activations-card-margin': isDiagnosePage
                    }"
                >
                    {{ cardContent.title | translate }}
                </div>
                <div class="tapestry-body body--sm">
                    {{ cardContent.subtitle | translate }}
                </div>
            </div>
        </div>
    </div>`,
    standalone: false
})
export class InternalActivationsCardComponent {
    @Input()
    cardContent: InternalActivationsCardContent;
    @Input() isDiagnosePage = false;
}
